import {ADD_ANNOUNCEMENTS, SET_ANNOUNCEMENTS_END, CLEAR_ANNOUNCEMENTS} from 'actions/types';


export default (state = {items:[], nextDate:null, end:false}, action) => {
    switch(action.type) {
        case ADD_ANNOUNCEMENTS: 
            return {...state, items:state.items.concat(action.announcements), nextDate:action.nextDate};
        case SET_ANNOUNCEMENTS_END: 
            return {...state, end:true};
        case CLEAR_ANNOUNCEMENTS: 
            return {...state, items:[], nextDate:null, end:false};
        default:            
            return state;
    }
}

//selectors
export const getAnnouncements  = state => state.items;
export const getNextDate  = state => state.nextDate;
export const getEnd  = state => state.end;



// WEBPACK FOOTER //
// ./src/reducers/announcements.js